import { TournamentCard } from '@pickleballinc/features/src/global/cards/TournamentCardv2';
import { formatLocation } from '@pickleballinc/lib/format-location';
import { RankingStatusBadge } from '@pickleballinc/ui/components/global/RankingStatusBadge/RankingStatusBadge';
import { useEffect, useState } from 'react';

import { useTournamentFavorite } from '@/hooks/tourney/useFavoriteToggle';
import { publicEnv } from '@/lib/env';
import { FavoritePPATournamentCard } from '@/modules/players/v2/tabs/components/FavoritePPATournamentCard';
import { FavoriteTournamentCard } from '@/modules/players/v2/tabs/components/FavoriteTournamentCard';
import { PPA_CLUB_ID } from '@/modules/players/v2/tabs/constants';
import { PlayerTournamentsData } from '@/types/playerTournaments.types';
import { FEATURE_FLAGS } from '@/utils/helpers/constants';

interface PlayerTournamentCardProps {
  tourney: PlayerTournamentsData;
  showWaitingList?: boolean;
  isManagingCard?: boolean;
  shouldHideFavoriteButton?: boolean;
  onRefetch?: () => void;
}

export const PlayerTournamentCard = ({
  tourney,
  isManagingCard,
  shouldHideFavoriteButton,
  onRefetch,
}: PlayerTournamentCardProps) => {
  const [pbracketsURL, setPbracketsURL] = useState('');

  const isTournamentPPA = tourney.clubId === PPA_CLUB_ID;

  useEffect(() => {
    const url = new URL(`${publicEnv.NEXT_PUBLIC_PBRACKETS_URL}/redirect_r.aspx`);
    url.searchParams.set('mf', 't');
    url.searchParams.set('mid', tourney.tournamentUuid);
    url.searchParams.set('todo', 'm');
    url.searchParams.set('rurl', window.location.href);

    setPbracketsURL(url.toString());
  }, []);

  return (
    <div className='flex flex-col sm:h-full gap-2'>
      {FEATURE_FLAGS.ENABLE_RANKING_BADGES ? (
        <RankingStatusBadge rankingStatus={tourney.badgeTitle} showBadge={tourney.showBadgeTitle} />
      ) : null}
      {isTournamentPPA ? (
        <FavoritePPATournamentCard
          moduleUuid={tourney.tournamentUuid}
          id={tourney.tournamentUuid}
          dateFrom={tourney.tourneyFromDate}
          dateTo={tourney.tourneyToDate}
          isCanceled={tourney.cancelTourney}
          isCostPerEvent={tourney.costFeeOnEvents}
          currency={tourney.paymentCurrencyAbbreviation}
          location={formatLocation([
            tourney.locationCity,
            tourney.locationState,
            tourney.locationCountry,
          ])}
          isRegistrationClosed={tourney.isRegClosed}
          logo={tourney.logo}
          price={tourney.costRegistrationCurrent}
          registrationCount={tourney.registrationCount}
          slug={tourney.slug || tourney.tournamentUuid}
          title={tourney.title}
          tournamentsAppBaseURL={`${publicEnv.NEXT_PUBLIC_PT_URL}`}
          isFavorite={tourney.isFavorite}
          shouldHideFavoriteButton={shouldHideFavoriteButton}
          onRefetch={onRefetch}
        />
      ) : FEATURE_FLAGS.ENABLE_NEW_CARDS ? (
        <TournamentCard
          {...tourney}
          tournamentsAppBaseURL={publicEnv.NEXT_PUBLIC_PT_URL}
          isTournamentsApp
          useFavoriteState={useTournamentFavorite}
          showFavoriteIcon
          initialIsFavorite={tourney.isFavorite}
          id={tourney.tournamentUuid}
          dateFrom={tourney.tourneyFromDate}
          dateTo={tourney.tourneyToDate}
          isCanceled={tourney.cancelTourney}
          isCostPerEvent={tourney.costFeeOnEvents}
          currency={tourney.paymentCurrencyAbbreviation}
          location={formatLocation([
            tourney.locationCity,
            tourney.locationState,
            tourney.locationCountry,
          ])}
          isRegistrationClosed={tourney.isRegClosed}
          logo={tourney.logo}
          price={tourney.costRegistrationCurrent}
          registrationCount={tourney.registrationCount}
          slug={tourney.slug || tourney.tournamentUuid}
          title={tourney.title}
        />
      ) : (
        <FavoriteTournamentCard
          moduleUuid={tourney.tournamentUuid}
          id={tourney.tournamentUuid}
          dateFrom={tourney.tourneyFromDate}
          dateTo={tourney.tourneyToDate}
          isCanceled={tourney.cancelTourney}
          isCostPerEvent={tourney.costFeeOnEvents}
          currency={tourney.paymentCurrencyAbbreviation}
          location={formatLocation([
            tourney.locationCity,
            tourney.locationState,
            tourney.locationCountry,
          ])}
          isRegistrationClosed={tourney.isRegClosed}
          logo={tourney.logo}
          price={tourney.costRegistrationCurrent}
          registrationCount={tourney.registrationCount}
          slug={tourney.slug || tourney.tournamentUuid}
          title={tourney.title}
          tournamentsAppBaseURL={isManagingCard ? pbracketsURL : `${publicEnv.NEXT_PUBLIC_PT_URL}`}
          isFavorite={tourney.isFavorite}
          shouldHideFavoriteButton={shouldHideFavoriteButton}
          onRefetch={onRefetch}
        />
      )}
    </div>
  );
};
